import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@mui/material'
import withStyles from '@mui/styles/withStyles'

import AcquiringApiRegenerateModal from 'components/core/Acquiring/AcquiringApi/components/AcquiringApiRegenerateModal'
import { TableFrame, TableHeader } from 'components/core/Tables'
import { themeStyles } from 'themes'
import combineStyles from 'utils/combineStyles'

const AcquiringApi: React.FC<AcquiringApiProps> = ({ classes }) => {
    const { t } = useTranslation()

    return (
        <>
            <h3>{t('Acquiring.API')}</h3>
            <div className={classes.acquiringApiCredentialsCard}>
                <div className={classes.acquiringTables}>
                    <div className={classes.acquiringApiCredentialsTable}>
                        <TableFrame>
                            <TableHeader tableHeader={t('Acquiring.ClientPublicKey')} />
                            <AcquiringApiRegenerateModal>
                                <Button
                                    className={classes.buttonBig}
                                    style={{ marginTop: 20, marginBottom: 20 }}
                                    variant="contained"
                                    color="primary"
                                >
                                    {t('Acquiring.Regenerate')}
                                </Button>
                            </AcquiringApiRegenerateModal>
                        </TableFrame>
                    </div>
                </div>
                <br />
            </div>
        </>
    )
}

export default withStyles(combineStyles(themeStyles.useAcquiringStyles, themeStyles.useTableStyles))(AcquiringApi)
